import { gql } from '@apollo/client';

export const GET_DOMAIN_BY_ORIGIN = gql`
  query DOMAIN_SERVICE_getDomainByOrigin($origin: String) {
    getDomainByOrigin(origin: $origin) {
      id
      name
      logo
      headerStyleId
      properties
      messages
    }
  }
`;

export const DOMAIN_PRODUCT_LINES = gql`
  query DOMAIN_SERVICE_getProductLines($inputFilter: InputFilterDTO!) {
    getProductLines(inputFilter: $inputFilter) {
      name
      rateSegment
      bcFormId
      dependentOnProductLineId
      eStoreBcFormId
      eStorePrerequisiteFormId
      productLineId
      configurablePlans
      eStoreHelpMeDecide
    }
  }
`;

export const DOMAIN_V2_CONFIG_BY_DATE = gql`
  query DOMAIN_SERVICE_V2_getConfigByEffectiveDate($id: ID!, $effectiveDate: String) {
    getConfigByEffectiveDate(id: $id, effectiveDate: $effectiveDate)
  }
`;
